/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import {clone, find, propEq} from 'ramda';

const List = styled.ul`
	flex: 0 1 ${({width}) => width ? width : '100%'};
	list-style: none outside;
	overflow: auto;
	${({isreport}) => isreport ? 'max-height: 250px;' : 'max-height: 400px;'}
`;

const ListItem = styled.li`
	font-size: 19px;
	color: ${({selected}) => selected ? '#43abf3' : '#3b3b3b'};
	padding-bottom: 15px;
	cursor: pointer;

	& + li {
		padding-top: 25px;;
		border-top: 1px solid #95989a;
	}
`;

class InputList extends React.Component {
    constructor(props) {
        super(props);


        const mergeme = x => x.value.selected = x.selected;
        let items = R.forEach(mergeme, clone(this.props.items));

        this.state = {
            items: R.pluck('value', items),
        };
    }

    selectItem = (itemIndex) => {

        const {items} = this.state;
        const {isDepartment} = this.props;
        if (!isDepartment) {
            const selectedItem = find(propEq('selected', true))(items);
            const item = items[itemIndex];

            if (selectedItem) {
                selectedItem.selected = false;
            }

            item.selected = true;

            this.props.handleClick(item);
            this.setState({items});
        } else {
            // Multiselect:
            const selectedItem = find(propEq('selected', true))(items);
            const item = items[itemIndex];

            item.selected = !item.selected;

            this.props.handleClick(item);
            this.setState({items});
        }

    };

    render() {
        const {isreport, width, selectedSize = null, isDepartment} = this.props;
        const getDisplayValue = (item) => {
            if (isDepartment) return item.name;
            if (R.isNil(item.departmentEntity)){
                return item.fullname + ' (!)'
            } else {
                return item.fullname + ' (' + item.departmentEntity.name +  ')'
            }
        };
        return (
            <List width={width} isreport={isreport}>
                {this.state.items.map((item, index) => (
                    <ListItem
                        key={`list-item-${index}-${item.selectionorder}`}
                        onClick={() => this.selectItem(index)}
                        selected={item.selected}
                        className={`${item.selected ? 'selected' : ''}`}
                        selectedSize={selectedSize}
                        used={item.used}
                    >
                        {getDisplayValue(item)}
                    </ListItem>

                ))}
            </List>
        )
    }
}

export default InputList;



// WEBPACK FOOTER //
// ./src/containers/disponent/input-list.js